import { SubscriptionCenterLocalizationRoute } from './-subscription-center-routes';
import { createFileRoute } from '@tanstack/react-router';

/** `lang` names the language being translated, as an LCID (`es`, `pt-BR`). */
type LocalizationEditSearch = { lang?: string };

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/settings/subscription_center/localization/edit',
)({
  component: SubscriptionCenterLocalizationRoute,
  // oxlint-disable-next-line local-rules/no-unsafe-dictionary-type -- validateSearch is handed unparsed search input, and the pass-through carries those same unvalidated values
  validateSearch: (search: Record<string, unknown>): Record<string, unknown> & LocalizationEditSearch => ({
    ...search,
    lang: typeof search.lang === 'string' ? search.lang : undefined,
  }),
});
